export default __webpack_public_path__ + "static/media/studing.4c50cb0a.png";